// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.231",
  "gitHash": "3293d24c36d673eeef864f5cd125c30a89b310b4",
  "versionWithHash": "5.5.231-3293d24c36d673eeef864f5cd125c30a89b310b4"
};
